import { Card, Icon, IconButton, Tooltip } from "@/components/atoms";
import { useAppDispatch } from "@/redux/hooks";
import { setAction } from "@/redux/slices/booking/bookingSlice";
import { BookingDetails } from "@/redux/slices/booking/types";
import { DetailField } from "../../../common/DetailField";
import { useIsOperatorOwnJob } from "../../../hooks/useIsOperatorOwnJob";

interface MessageSectionProps {
  booking: BookingDetails;
}

export const MessageSection = ({ booking }: MessageSectionProps) => {
  const dispatch = useAppDispatch();
  const isOwnJob = useIsOperatorOwnJob();
  const { metadata } = booking;

  const handleMessageLogsClick = () => {
    dispatch(setAction("message-log"));
  };

  if (metadata.isAcceptedFromNetwork) {
    return null;
  }

  if (metadata.isOffloaded && !isOwnJob) return null;

  return (
    <Card className="p-2.5">
      <DetailField
        leading={<Icon name="MessageNotif" size="lg" className="text-neutral-dark-gray" />}
        label="Message Logs"
        right={
          <Tooltip content="View Job Messaging Logs" placement="top">
            <IconButton
              iconName="ArrowRight"
              iconSize="md"
              size="xs"
              variant="primary"
              className="h-8 w-8"
              onClick={handleMessageLogsClick}
            />
          </Tooltip>
        }
      />
    </Card>
  );
};
